// 阿里云oss存储
const OSS = require('ali-oss')
// const ossEndpoint = 'oss-cn-hangzhou.aliyuncs.com/';
// const client = new OSS({
// 	// region填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
// 	region: 'oss-cn-hangzhou',
// 	// 阿里云账号RAM用户进行API访问或日常运维。
// 	accessKeyId: 'LTAI5tFxvRJyirFnjV3B37nm',
// 	accessKeySecret: 'BqxVYN5eLgI4KjQZod3I13pynamg9a',
// 	bucket: 'mango24',
// 	secure: false, //是否启用https访问资源 小程序必须https 默认false
// })
const headers = {
	// 指定Object的存储类型。
	'x-oss-storage-class': 'Standard',
	// 指定Object标签，可同时设置多个标签。
	'x-oss-tagging': 'Tag1=1&Tag2=2',
	// 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
	'x-oss-forbid-overwrite': 'true'
}
const progress = (p, _checkpoint) => {
	// Object的上传进度。
	console.log(p);
	// 分片上传的断点信息。
	console.log(_checkpoint);
};
export {
	OSS,
	progress
}